import { StoreInventoryRow } from 'src/domain/table/store-inventory.row';
import { CreateStoreFurnitureInput } from 'src/infrastructure/rest-api/api-types';
import { isPersistedFurnitureColumnType } from 'src/utils/furnitureUtils';

export const mapFurnitureZoneChangesToPayload = (
    unsavedChanges: Map<number, Partial<StoreInventoryRow>>
): CreateStoreFurnitureInput[] => {
    return Array.from(unsavedChanges.entries()).flatMap(([storeId, changedRow]) => {
        return Object.values(changedRow.furnitureColumns ?? {})
            .filter(isPersistedFurnitureColumnType)
            .map((data) => ({
                storeId,
                chainFurnitureId: data.chainFurnitureId,
                numberOfOptions: data.optionCount,
                chainFurnitureZoneId:
                    data.chainFurnitureZoneId == null ||
                    data.chainFurnitureZoneId.toString().trim() === '' ||
                    Number(data.chainFurnitureZoneId) === 0
                        ? null
                        : Number(data.chainFurnitureZoneId),
            }));
    });
};
